import { CustomCell } from './components/custom-claim-cell/index';
import { getStringOperators } from '../../utils/getStringOperators';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { getDateOperators } from '../../utils/getDateOperators';
import { getSingleSelectOperators } from '../../utils/getSingleSelectOperators';

export const TABLE_COLUMNS = (sections, categories, priorities) => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Дата',
			field: 'created_at',
			width: 130,
			type: 'date',
			filterOperators: getDateOperators(),
			formatter: value => new Date(value).toLocaleDateString('ru-RU'),
			valueGetter: (value, row) => {
				if (!row.created_at) {
					return value;
				}

				return new Date(row.created_at);
			},
		},
		{
			headerName: 'Заявка',
			field: 'req_id',
			width: 130,
			align: 'left',
			headerAlign: 'left',
			type: 'number',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Раздел',
			field: 'section_id',
			flex: 1,
			sortable: false,
			type: 'singleSelect',
			valueOptions: sections,
			filterOperators: getSingleSelectOperators(),
			getOptionValue: value => value?.id,
			getOptionLabel: value => value?.name ?? 'Все',
			valueGetter: (value, row) => {
				if (!row.req) {
					return value;
				}

				return row.req?.category?.id;
			},
		},
		{
			headerName: 'Категория',
			field: 'category_id',
			flex: 1,
			sortable: false,
			type: 'singleSelect',
			valueOptions: categories,
			getOptionValue: value => value?.id,
			getOptionLabel: value => value?.name ?? 'Все',
			valueGetter: (value, row) => {
				if (!row.category) {
					return value;
				}

				return row.category.id;
			},
		},
		{
			headerName: 'От кого',
			field: 'from',
			flex: 1,
			sortable: false,
			filterOperators: getStringOperators(),
		},
		{ headerName: 'К кому', field: 'to', flex: 1, sortable: false, filterOperators: getStringOperators() },
		{
			headerName: 'Приоритет',
			field: 'priority_id',
			flex: 1,
			sortable: false,
			type: 'singleSelect',
			valueOptions: priorities,
			getOptionValue: value => value?.id,
			getOptionLabel: value => value?.name ?? 'Все',
			valueGetter: (value, row) => {
				if (!row.priority) {
					return value;
				}

				return row.priority.id;
			},
		},
	];
};

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const TABS = [
	{ key: 'opened', text: 'Новые', href: '/claims/opened' },
	{ key: 'approve', text: 'Необходимо согласовать', href: '/claims/approve' },
	{ key: 'approval', text: 'На согласовании', href: '/claims/approval' },
	{ key: 'closed', text: 'Завершенные', href: '/claims/closed' },
];
